export enum ECourseRequestType {
    GENERAL_SEARCH = 'GENERAL_SEARCH',
    BY_CRN = 'BY_CRN',
    FACULTY_COURSES = 'FACULTY_COURSES',
    STUDENT_COURSES = 'STUDENT_COURSES',
    LUOA_EXTENSION = 'LUOA_EXTENSION',
    LUOA_APPEAL = 'LUOA_APPEAL',
    CSER_APPEAL = 'CSER_APPEAL'
}